/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'help-list': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M930.998 0H177.334C88.246 0 51.382 40.96 51.382 128v732.16a70.656 70.656 0 000 14.336C51.382 977.92 90.806 1024 198.326 1024h732.672a42.496 42.496 0 0041.984-42.496V42.496A42.496 42.496 0 00930.998 0zm-586.24 65.024h125.44v374.784l-64-42.496-61.44 42.496zm563.2 899.584H172.726a64 64 0 010-128h736.768v128zm0-182.784H172.726a143.872 143.872 0 00-62.976 14.336V107.52a43.008 43.008 0 0112.288-30.208 41.472 41.472 0 0131.744-12.288h132.096v452.608a20.992 20.992 0 0010.752 18.432 19.968 19.968 0 0020.992 0l76.8-60.416a19.968 19.968 0 0120.992 0l82.432 61.44a19.968 19.968 0 0020.992 0 20.992 20.992 0 0010.24-18.432V65.024h380.416z"/>'
  }
})
